import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { toast } from '@/components/ui/Toast'
import type { CreatePost } from '@parchala/shared'

export function useCreatePost() {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: (data: CreatePost) => api.post('/api/posts', data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['feed'] })
      toast.success('Publicación creada ✓')
    },
    onError: (err: Error) => toast.error(err.message),
  })
}

export function useDeletePost() {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => api.delete(`/api/posts/${id}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['feed'] })
      toast.success('Publicación eliminada')
    },
    onError: (err: Error) => toast.error(err.message),
  })
}

export function useToggleInterest(postId: string) {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: (interested: boolean) => api.post(`/api/posts/${postId}/interest`, { interested }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['feed'] })
      qc.invalidateQueries({ queryKey: ['interests'] })
    },
    onError: (err: Error) => toast.error(err.message),
  })
}

export function useToggleSave(postId: string) {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: (saved: boolean) => api.post(`/api/posts/${postId}/save`, { saved }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['saved'] }),
    onError: (err: Error) => toast.error(err.message),
  })
}
